import type { SegmentDecision, VacationRequestStatus } from '../models/vacation.types';

interface ResolveDpOutcomeInput {
    segmentDecisions: Record<string, { decision: 'approve' | 'reject'; note: string }>;
    previousDecisions?: Record<string, SegmentDecision>;
    totalSegments: number;
}

export function resolveDpOutcome({
    segmentDecisions,
    previousDecisions = {},
    totalSegments,
}: ResolveDpOutcomeInput): VacationRequestStatus {
    if (totalSegments === 1) {
        const decision = segmentDecisions['1'];
        return decision?.decision === 'approve' ? 'Scheduled' : 'Rejected';
    }

    const mergedDecisions: Record<string, 'approve' | 'reject'> = {};

    for (let i = 1; i <= totalSegments; i++) {
        const orderStr = String(i);
        const previous = previousDecisions[orderStr];
        const current = segmentDecisions[orderStr];

        if (previous?.status === 'Approved') {
            mergedDecisions[orderStr] = 'approve';
        } else if (current) {
            mergedDecisions[orderStr] = current.decision;
        } else {
            mergedDecisions[orderStr] = 'reject';
        }
    }

    const allApproved = Object.values(mergedDecisions).every((d) => d === 'approve');
    const allRejected = Object.values(mergedDecisions).every((d) => d === 'reject');

    if (allApproved) return 'Scheduled';
    if (allRejected) return 'Rejected';
    return 'PendingCorrection';
}
